/**
 * Debug utility for Spotify Funnel Chart
 * This helps diagnose why the chart might not be displaying
 */

import { apiFetch } from '../services/api/client';
import { DEFAULT_ARTIST_ID } from '../config/nova-constants';

export const debugSpotifyFunnel = async (clickhouseArtistId?: string) => {
  const effectiveClickhouseArtistId = clickhouseArtistId || DEFAULT_ARTIST_ID;

  try {
    return await apiFetch(`/multi-analytics/spotify-funnel/${effectiveClickhouseArtistId}`);
  } catch (error) {
    throw error;
  }
};

// Export for console debugging
(window as any).debugSpotifyFunnel = debugSpotifyFunnel;
